export const headerBtnAppend = () => {
  const headerLink = document.querySelector(".header__link");

  if (headerLink) {
    const menu = document.querySelector(".menu");
    const originalParent = headerLink.parentElement;

    function moveHeaderLink() {
      if (window.innerWidth < 600) {
        if (!menu.contains(headerLink)) {
          menu.appendChild(headerLink);
        }
      } else {
        if (!originalParent.contains(headerLink)) {
          originalParent.appendChild(headerLink);
        }
      }
    }
    window.addEventListener("load", moveHeaderLink);
  }
};
